import { ComponentCmsDataFormQuestion } from "@/generated";
import clsx from "clsx";

interface QuestionContentProps {
  question: ComponentCmsDataFormQuestion;
}

export const QuestionContent: React.FC<QuestionContentProps> = ({
  question,
}) => {
  return (
    <div
      className={clsx(question.center_text && "text-center pt-2 px-2 lg:py-4")}
    >
      <h2
        className={clsx([
          "font-bold mb-6",
          question.size === "small" && "!text-xl",
          question.size === "medium" && "!text-3xl",
          question.size === "large" && "!text-5xl",
          !question.size && "text-3xl",
        ])}
        style={{ color: question.title_color || "#13235b" }}
      >
        {question.title}
        {question.is_required ? "*" : ""}
      </h2>
      <p
        className={clsx([
          question.size === "small" && "text-base",
          question.size === "medium" && "text-lg",
          question.size === "large" && "text-2xl",
          !question.size && "text-lg",
        ])}
        style={{ color: question.description_color || "#1089c6" }}
      >
        {question.description}
      </p>
    </div>
  );
};
